const apiPaths = {
  sessionState: '/video-editor/:userId/:fileId',
  clips: '/video-editor/:userId/:fileId/clips',
  titleFrames: '/video-editor/:userId/:fileId/title-frames',
  merge: '/video-editor/:userId/merge'
};

export function useVideoEditorApi() {
  const session = useSessionStore();
  const api = useLocalApi();

  return {
    async getVideoEditorSession({fileId, userId = session.currentUserId}) {
      return api.fetch(
        apiPaths.sessionState, {
          params: {
            route: {
              fileId,
              userId
            }
          }
      });
    },

    async updateVideoEditorSession({fileId, userId = session.currentUserId, clips, status}) {
      return api.put(
        apiPaths.sessionState, {
          params: {
            route: {
              fileId,
              userId
            }
          },
          body: {
            clips,
            status
          }
        }
      );
    },

    async createVideoClipJob({userId = session.currentUserId, fileId, clips, mode, contextType, contextId}) {
      const body = {
        fileId,
        mode,
        clips
      };

      if (contextType && contextId && contextType !== FILE_CONTEXTS.container) {
        body.contextType = contextType;
        body.contextId = contextId;
      }

      return api.post(
        apiPaths.clips,
        {
          params: {
            route: {
              fileId,
              userId
            }
          },
          body
        }
      );
    },

    async createVideoMergeJob({userId = session.currentUserId, outputName, fade, sourceFiles, contextType, contextId}) {
      const body = {
        outputName,
        fade,
        sourceFiles
      };

      if (contextType && contextId && contextType !== FILE_CONTEXTS.container) {
        body.contextType = contextType;
        body.contextId = contextId;
      }

      return api.post(
        apiPaths.merge,
        {
          params: {
            route: { userId }
          },
          body
        }
      );
    },

    async getTitleFrameUploadUrls({userId = session.currentUserId, fileId, items = []}) {
      return api.post(
        apiPaths.titleFrames,
        {
          params: {
            route: {
              fileId,
              userId
            }
          },
          body: {
            items
          }
        }
      );
    }
  };
}
